import { mediaQueriesBP } from "@bevco/Utilities/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    height: number;
    heightMobile: number;
    extendedStyles?: SpacerStyles;
}

export type Props = OwnProps & HasShellContext;

export interface SpacerStyles {
    container?: InjectableCss;
    editStyle?: InjectableCss;
}

export const spacerStyles: SpacerStyles = {
    container: {
        css: css`
            width: 100%;
        `,
    },
    editStyle: {
        css: css`
            background-color: #fff;
            background-size: 20px 20px;
            background-position: 0 0, 30px 30px;
            background-image:
                linear-gradient(45deg, #e5e5e5 25%, transparent 25%, transparent 75%, #e5e5e5 75%, #e5e5e5),
                linear-gradient(45deg, #e5e5e5 25%, transparent 25%, transparent 75%, #e5e5e5 75%, #e5e5e5);
        `,
    },
};

export const styles = spacerStyles;

export const Spacer = withIsInShell(({ height, heightMobile, shellContext: { isEditing } }: Props) => {
    const editWrapper: InjectableCss = {};
    if (isEditing) {
        editWrapper.css = css`
            ${styles.editStyle?.css}
        `;
    }

    const wrapper = {
        css: css`
            ${styles.container?.css}
            ${editWrapper.css}

            ${mediaQueriesBP.maxMD} {
                height: ${heightMobile}px;
            }

            ${mediaQueriesBP.minMD} {
                height: ${height}px;
            }
        `,
    };

    return <StyledWrapper {...wrapper} />;
});
